import { useTranslation } from "react-i18next";

const LANGUAGES = [
  { code: "es", label: "ES" },
  { code: "en", label: "EN" },
];

export default function LanguageSwitch() {
  const { i18n, t } = useTranslation();
  const current = i18n.language.startsWith("en") ? "en" : "es";

  const change = (code: string) => {
    if (code !== current) {
      i18n.changeLanguage(code);
    }
  };

  return (
    <div
      role="group"
      aria-label={t("header.switchAria")}
      className="flex items-center gap-1 rounded-full border border-background-300/70 px-1 py-1"
    >
      {LANGUAGES.map((lang) => {
        const active = current === lang.code;
        return (
          <button
            key={lang.code}
            type="button"
            onClick={() => change(lang.code)}
            aria-pressed={active}
            className={`press min-w-[32px] cursor-pointer rounded-full px-2 py-1 font-body text-xs tracking-wide transition-colors ${
              active
                ? "bg-primary-500 text-foreground-950"
                : "text-secondary-500 hover:text-primary-500"
            }`}
          >
            {lang.label}
          </button>
        );
      })}
    </div>
  );
}